import { useId, type HTMLAttributes, type ReactNode } from 'react';
import styles from './FormSection.module.css';

export type FormSectionProps = Omit<HTMLAttributes<HTMLElement>, 'title'> & {
  title: string;
  description?: string | undefined;
  icon?: ReactNode;
  status?: ReactNode;
  variant?: 'card' | 'plain';
};

export const FormSection = ({
  title,
  description,
  icon,
  status,
  variant = 'card',
  className,
  children,
  ...rest
}: FormSectionProps) => {
  const titleId = useId();
  return (
    <section
      className={[styles['section'], styles[variant], className ?? ''].join(' ')}
      aria-labelledby={titleId}
      {...rest}
    >
      <header className={styles['header']}>
        {icon ? (
          <span className={styles['icon']} aria-hidden="true">
            {icon}
          </span>
        ) : null}
        <div className={styles['heading']}>
          <h2 id={titleId} className={styles['title']}>
            {title}
          </h2>
          {description ? <p className={styles['description']}>{description}</p> : null}
        </div>
        {status}
      </header>
      <div className={styles['body']}>{children}</div>
    </section>
  );
};
